import { Dispatch } from "@reduxjs/toolkit";
import apiFetch from "../token-guard/apiFetch";

export async function getUserProfile(dispatch: Dispatch<any>): Promise<any> {
  try {
    const response = await apiFetch(
      "/api/profile/get",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    );

    return await response;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    return null;
  }
}
